import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get values() {
        return {
            releases: Array,
        }
    }

    static get targets() {
        return [
            'releases',
        ]
    }

    async connect() {
        const axios = await import(/* webpackChunkName: "vendor-axios" */ 'axios');
        axios('/wp-json/wp/v2/release?_embed')
            .then((response) => {
                return response.data;
            })
            .then((data) => {
                return data.filter((entry) => {
                    const {
                        _embedded,
                        content,
                        excerpt,
                    } = entry;

                    const img = _embedded['wp:featuredmedia'];

                    switch(true) {
                        case ![null, undefined].includes(img):
                            return true;
                        case content.protected:
                        case excerpt.protected:
                        default:
                            return false;
                    }
                })
            })
            .then((data) => {
                this.releasesValue = data;
            })
    }

    releasesValueChanged() {
        if(this.releasesValue == null) {
            return null;
        }

        this.render();
    }

    render() {
        const FeedItem = (props, index) => {
            const {
                title,
                _embedded,
                excerpt,
                link,
            } = props;

            const img = _embedded['wp:featuredmedia'];
            const button_type = index == 0 ? 'btn btn-primary' : 'btn btn-underline';

            return `
                <a class="feed-item" href='${ link }'>
                    <div class="feed-item-image">
                       <img src='${ img[0].source_url }' />
                    </div>
                    <div class="feed-item-content">
                        <h2>${ title.rendered }</h2>
                        ${ excerpt.rendered }
                        <button class="${ button_type }">Learn More</button>
                    </div>
                </a>
            `;
        }

        this.releasesTarget.innerHTML = (this.releasesValue.map((release, index) => FeedItem(release, index))).join('');
    }
}
